import { gql } from '@apollo/client';
import Fragments from '../fragments/fragments';
import UserInfoFragments from 'features/userProfile/fragments/fragments';

export const GET_COMMENTS_QUERY = gql`
  query getComments($documentId: Int!, $siteId: Int!) {
    getComments(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      userId
      list {
        ...comment
      }
      usersAdditionalData {
        ...userAdditionalData
      }
    }
  }
  ${Fragments.comment}, ${UserInfoFragments.userAdditionalData}
`;

export const COMMENTS_USER_AGENDA_QUERY = gql`
  query getCommentsUserAgenda($documentId: Int!, $siteId: Int!, $userId: Int!) {
    getCommentsUserAgenda(documentId: $documentId, siteId: $siteId, userId: $userId) {
      contactName
      email
      userId
      isStandardContact
      userGroupId
      role
    }
  }
`;
